module.exports = __webpack_public_path__ + "static/media/icon-forward.d9da3e93.svg";